export const getDate = (value: any) => {

  try {
    if (value != undefined && value != null) {
      return new Date(value);
    }

  } catch (error) {
    console.log("dateError", error)
  }
  return undefined;
};

export function parseDateStringToLocal(dateStr: string) {
  const [datePart, timePart] = dateStr.split(" ");
  const [day, month, year] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  // Create date in local time
  return new Date(year, month - 1, day, hour, minute, second);
}